import styled from 'styled-components';

export const CardContainer = styled.div`
  padding: ${props => props.theme.global.gutterSpace * 1.25}px;
  display: flex;
  align-items: center;
  border: 1px solid ${props => props.theme.colors.grey200};
  border-radius: ${props => props.theme.forms.borderRadius}px;
  cursor: pointer;
  transition: all 0.125s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    -webkit-box-shadow: 0px 5px 5px 0px rgba(176, 176, 176, 0.4);
    box-shadow: 0px 5px 5px 0px rgba(176, 176, 176, 0.4);
  }
`;

export const LeftSide = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
`;

export const Header = styled.h1`
  display: flex;
  align-items: center;
  margin-bottom: ${props => props.theme.global.gutterSpace}px;
`;

export const Title = styled.div`
  font-weight: 600;
  font-size: ${props => props.theme.fontSizes[3]};
  color: ${props => props.theme.colors.grey900};
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
`;

export const InformationSection = styled.div`
  display: flex;
  align-items: center;
`;

export const InfoTitle = styled.div`
  padding-bottom: ${props => props.theme.global.gutterSpace * 0.76}px;
  font-weight: 500;
  font-size: ${props => props.theme.fontSizes[2]};
  color: ${props => props.theme.colors.grey700};
`;

export const InfoValue = styled.div`
  font-weight: 500;
  font-size: ${props => props.theme.fontSizes[3]};
  color: ${props => props.theme.colors.grey900};
`;

export const Col = styled.div`
  min-width: 150px;
`;
